var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.998,
    viewBox: "0 0 24 23.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,24H5L0,24V19L14.745,4.253l5,5ZM14.745,8.026h0L2.666,20.105v1.226H3.893L15.972,9.252,14.745,8.026Zm6.426-.2h0l-5-5,2.44-2.44a1.336,1.336,0,0,1,1.88,0l3.12,3.12a1.331,1.331,0,0,1,0,1.88l-2.439,2.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.277ee954326f07d0c8cbfc9c082aa449.svg";
export { ForwardRef as ReactComponent };